module.exports = __webpack_public_path__ + "ghnc-14e92acd112b0f99a590aa02a60a93cf.png";


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Partners/ghnc.png
 ** module id = 458
 ** module chunks = 0
 **/